import {match, MatchFunction} from 'path-to-regexp';

import {PAGES} from "@stores/ViewStore";


export interface Route {
    pattern: string;
    action: (
        pathParams: Record<string, string>,
        queryParams: Record<string, string>,
        hashString?: string,
    ) => void;
    public?: boolean;
}

export type ParseRoute = Pick<Route, 'action' | 'public'> & {
    checkMatch: MatchFunction<Record<string, string>>;
}

export const createRouter = (
    routers: Route[],
    defaultAction: (queryParams:  Record<string, string>) => void
) => {
    const parsedRoutes: ParseRoute[] = [];

    for (const route of routers) {
        const urlMatch = match<Record<string, string>>(route.pattern, {
            decode: decodeURIComponent,
        });
        parsedRoutes.push({
            checkMatch: urlMatch,
            action: route.action,
            public: !!route.public,
        })
    }


    return (url: string, searchString: string, hashString?: string) => {
        const queryParams: Record<string, string> = {};
        const queryParsed = new URLSearchParams(searchString);
        for(const [key, value] of queryParsed.entries()) {
            queryParams[key] = value;
        }

        for (const parsedRoute of parsedRoutes) {
            const match = parsedRoute.checkMatch(url);
            if (match) {
                parsedRoute.action(match.params, queryParams, hashString);
                return;
            }
        }
        defaultAction(queryParams);
        return;
    }
}
